import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { RoutesPaths } from "./constant";
import Home from "../Pages/Home";
import About from "../Pages/About";
import Banner from "../Pages/Banner";
import Contact from "../Pages/Contact";
import Notfound from "../Components/Notfound";
import Esg from "../Pages/Essg";
import PrivateSector from "../Pages/Private-sector";
import PublicSector from "../Pages/Public-sector";
import OurPosition from "../Pages/Ourposition";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import TermsAndConditions from "../Pages/TermsAndConditions";

export default function RouteComponent() {
  return (
    <>
      <Routes>
        <Route exact path={RoutesPaths.HOME} element={<Home />} />
        <Route exact path={RoutesPaths.BANNER} element={<Banner />} />
        <Route exact path={RoutesPaths.ABOUT} element={<About />} />
        <Route exact path={RoutesPaths.ESG} element={<Esg />} />
        <Route exact path={RoutesPaths.CONTACT} element={<Contact />} />
        <Route exact path={RoutesPaths.PRIVATE_SECTOR} element={<PrivateSector />} />
        <Route exact path={RoutesPaths.PUBLIC_SECTOR} element={<PublicSector />}/>
        <Route exact path={RoutesPaths.OURPOSITION} element={<OurPosition />} />
        <Route exact path={RoutesPaths.PRIVACY_POLICY} element={<PrivacyPolicy />} />
        <Route exact path={RoutesPaths.TERMS_AND_CONDITIONS} element={<TermsAndConditions />} />
        <Route exact path={RoutesPaths.NOTFOUND} element={<Notfound />} />
        <Route path="*" element={<Navigate to={RoutesPaths.NOTFOUND} />} />
      </Routes>
    </>
  );
}
